/** A {@link PollController} at the interval of the configuration (`api.pollIntervalMs`). */
import { getConfig } from '../lib/config/manager.js';
import { PollController } from '../lib/poll/index.js';

export const poll = (host, load) => new PollController(host, load, getConfig().api?.pollIntervalMs ?? 5000);
